<div [ngClass]="'flip-card' + (_flipVis ? ' flip-vis' : '') + (_flipped ? ' flipped' : '')">
  <div class="flip-card-inner">
    <div class="flip-card-front">
      <ng-content select="#card1"></ng-content>
    </div>
    <div class="flip-card-back">
      <ng-content select="#card2"></ng-content>
    </div>
  </div>
</div>